export default __webpack_public_path__ + "static/media/logotipo_h.034376a1.svg";